import { render, staticRenderFns } from "./LabelAutoEntry.vue?vue&type=template&id=68dee180&scoped=true&"
import script from "./LabelAutoEntry.vue?vue&type=script&lang=js&"
export * from "./LabelAutoEntry.vue?vue&type=script&lang=js&"
import style0 from "./LabelAutoEntry.vue?vue&type=style&index=0&id=68dee180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dee180",
  null
  
)

export default component.exports